export const environment = {
  production: true,
  useEmulators: false,
  firebase: {
    apiKey: "AIzaSyC407RjBcFB6-Kki-PdulUCDL15hM66Ias",
    authDomain: "iris-414f9.firebaseapp.com",
    databaseURL: "https://iris-414f9.firebaseio.com",
    projectId: "iris-414f9",
    storageBucket: "iris-414f9.appspot.com",
    messagingSenderId: "802490473440",
    appId: "1:802490473440:web:6bb2371e22466e24e1a985",
    measurementId: "G-BWQVYTKN6P"
  },
  // menu
  tiles: [
    { color: '#f8ca6a', title: 'navigation.info', link: '/infoboard', image: 'assets/img/menu/info.svg', explanation: 'home.info_exp' },
    { color: '#8cd6ef', title: 'navigation.voice', link: '/voiceboard', image: 'assets/img/menu/voice.svg', explanation: 'home.voice_exp' },
    { color: '#7ee269', title: 'navigation.knowledge', link: '/knowledgeboard', image: 'assets/img/menu/knowledge.svg', explanation: 'home.knowledge_exp' },
    { color: '#f19ca7', title: 'navigation.systeminfo', link: '/systeminfo', image: 'assets/img/menu/system.svg', explanation: 'home.system_exp' },
    { color: '#c7a5cc', title: 'navigation.scholarship', link: '/scholarship', image: 'assets/img/menu/scholarship.svg', explanation: 'home.sholarship_exp' },
  ],
  // links
  links: [
    { url: 'https://www.mhlw.go.jp/mamorouyokokoro/', image: 'assets/img/link/kv_img.png', title: 'links.title01', content: 'links.content01'},
    // { url: 'https://me-x.jp/', image: 'assets/img/link/mex.png', title: 'links.title02', content: 'links.content02'},
    // { url: 'https://zenninnet-sos.org/', image: 'assets/img/link/ninshinsos.png', title: 'links.title03', content: 'links.content03'},
    { url: 'https://self-help-group.sakura.ne.jp/', image: 'assets/img/link/jijogroup.png', title: 'links.title04', content: 'links.content04'},
  ],
  // voice search
  voices: [
    // emotion
    {
      title: 'voice.search_emotion',
      content: [
        { tag: 'tag.happy', color: 'mistyrose' },
        { tag: 'tag.angry', color: 'lavenderblush' },
        { tag: 'tag.sad', color: 'seashell' },
        { tag: 'tag.fun', color: 'oldlace' },
        { tag: 'tag.trouble', color: 'ivory' },
        { tag: 'tag.suffering', color: 'honeydew' },
        { tag: 'tag.anxiety', color: 'mintcream' },
        { tag: 'tag.fear', color: 'azure' },
      ]
    },
    // experiense
    {
      title: 'voice.search_experience',
      content: [
        { tag: 'tag.group_home_nl', color: 'mistyrose' },
        { tag: 'tag.foster_parents', color: 'lavenderblush' },
        { tag: 'tag.independence_support_facility_nl', color: 'seashell' },
        { tag: 'tag.psychotherapy_facility_nl', color: 'oldlace' },
        { tag: 'tag.disabilitied_facility_nl', color: 'ivory' },
        { tag: 'tag.temporary_shelter', color: 'honeydew' },
        { tag: 'tag.adoption', color: 'mintcream' },
        { tag: 'tag.abuse', color: 'azure' },
        { tag: 'tag.independence support home_nl', color: 'aliceblue' },
        { tag: 'tag.mother_child_support_facility_nl', color: 'lavender' },
      ]
    },
    // life event
    {
      title: 'voice.search_life_event',
      content: [
        { tag: 'tag.independent', color: 'mistyrose' },
        { tag: 'tag.education', color: 'lavenderblush' },
        { tag: 'tag.work', color: 'seashell' },
        { tag: 'tag.love', color: 'oldlace' },
        { tag: 'tag.marriage_nl', color: 'ivory' },
        { tag: 'tag.sick', color: 'honeydew' },
        { tag: 'tag.life', color: 'mintcream' },
        { tag: 'tag.family', color: 'azure' },
        { tag: 'tag.school', color: 'aliceblue' },
        { tag: 'tag.friend', color: 'lavender' },
      ]
    }
  ],
  facilities: [
    { tag: 'tag.aftercare', color: 'accent', tooltip: 'tooltip.aftercare', checked: false },
    { tag: 'tag.place', color: 'accent', tooltip: '', checkd: false },
    { tag: 'tag.liveplace', color: 'accent', tooltip: 'tooltip.liveplace', checked: false },
    { tag: 'tag.jobmake', color: 'accent', tooltip: '', checked: false },
    { tag: 'tag.seminar', color: 'accent', tooltip: 'tooltip.seminar', checked: false },
    { tag: 'tag.participant_activity', color: 'accent', tooltip: '', checked: false }
  ],
  scholarships: [
    { name: 'scholarship.item01', sub: 'scholarship.item01_sub', pdf: 'http://www.zenyokyo.gr.jp/whatsnew/r1_seidoichiran.pdf ', url: 'http://www.zenyokyo.gr.jp/' },
    { name: 'scholarship.item02', sub: 'scholarship.item02_sub', pdf: 'https://compass-navi.or.jp/wp/wp-content/uploads/2021/09/ff09002c3200897598a43b17e415f440-3.pdf ', url: 'http://compass-navi.or.jp/' }
  ],
  tags: [
    'tag.group_home',
    'tag.foster_parents',
    'tag.independence_support_facility',
    'tag.psychotherapy_facility',
    'tag.disabilitied_facility',
    'tag.temporary_shelter',
    'tag.adoption',
    'tag.abuse',
    'tag.happy',
    'tag.angry',
    'tag.sad',
    'tag.fun',
    'tag.trouble',
    'tag.independent',
    'tag.education',
    'tag.work',
    'tag.love',
    'tag.marriage',
    'tag.sick',
    'tag.life',
    'tag.family',
    'tag.aftercare',
    'tag.place',
    'tag.liveplace',
    'tag.jobmake',
    'tag.seminar',
    'tag.participant_activity',
    'tag.scholarship'
  ],
  places: [
    {
      name: 'すべてを表示',
      prefectures: [
        { value: 'all', viewValue: '全国'}
      ]

    },
    {
      name: '北海道',
      prefectures: [
        { value: 'hokkaido', viewValue: '北海道'}
      ]
    },
    {
      name: '東北',
      prefectures: [
        { value: 'aomori', viewValue: '青森県'},
        { value: 'akita', viewValue: '秋田県'},
        { value: 'iwate', viewValue: '岩手県'},
        { value: 'yamagata', viewValue: '山形県'},
        { value: 'miyagi', viewValue: '宮城県'},
        { value: 'fukushima', viewValue: '福島県'}
      ]
    },
    {
      name: '関東',
      prefectures: [
        { value: 'tokyo', viewValue: '東京都'},
        { value: 'ibaraki', viewValue: '茨城県'},
        { value: 'tochigi', viewValue: '栃木県'},
        { value: 'gunma', viewValue: '群馬県'},
        { value: 'saitama', viewValue: '埼玉県'},
        { value: 'chiba', viewValue: '千葉県'},
        { value: 'kanagawa', viewValue: '神奈川県'}
      ]
    },
    {
      name: '中部',
      prefectures: [
        { value: 'nigata', viewValue: '新潟県'},
        { value: 'toyama', viewValue: '富山県'},
        { value: 'ishikawa', viewValue: '石川県'},
        { value: 'fukui', viewValue: '福井県'},
        { value: 'yamanashi', viewValue: '山梨県'},
        { value: 'nagano', viewValue: '長野県'},
        { value: 'gihu', viewValue: '岐阜県'},
        { value: 'shizuoka', viewValue: '静岡県'},
        { value: 'aichi', viewValue: '愛知県'},
      ]
    },
    {
      name: '近畿',
      prefectures: [
        { value: 'kyoto', viewValue: '京都府'},
        { value: 'ohsaka', viewValue: '大阪府'},
        { value: 'mie', viewValue: '三重県'},
        { value: 'shiga', viewValue: '滋賀県'},
        { value: 'hyogo', viewValue: '兵庫県'},
        { value: 'nara', viewValue: '奈良県'},
        { value: 'wakayama', viewValue: '和歌山県'}
      ]
    },
    {
      name: '中国',
      prefectures: [
        { value: 'okayama', viewValue: '岡山県'},
        { value: 'tottori', viewValue: '鳥取県'},
        { value: 'hiroshima', viewValue: '広島県'},
        { value: 'shimane', viewValue: '島根県'},
        { value: 'yamaguchi', viewValue: '山口県'}
      ]
    },
    {
      name: '四国',
      prefectures: [
        { value: 'tokushima', viewValue: '徳島県'},
        { value: 'kagawa', viewValue: '香川県'},
        { value: 'kochi', viewValue: '高知県'},
        { value: 'ehime', viewValue: '愛媛県'}
      ]
    },
    {
      name: '九州・沖縄',
      prefectures: [
        { value: 'fukuoka', viewValue: '福岡県'},
        { value: 'saga', viewValue: '佐賀県'},
        { value: 'nagasaki', viewValue: '長崎県'},
        { value: 'ohita', viewValue: '大分県'},
        { value: 'kumanoto', viewValue: '熊本県'},
        { value: 'miyazaki', viewValue: '宮崎県'},
        { value: 'kagoshima', viewValue: '鹿児島県'},
        { value: 'okinawa', viewValue: '沖縄県'}
      ]
    }
  ],
};
